import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Self-hosted brand fonts in light weights (bundled with the app, no third-party requests).
import '@fontsource/tajawal/arabic-300.css';
import '@fontsource/tajawal/arabic-400.css';
import '@fontsource/tajawal/arabic-500.css';
import '@fontsource/poppins/latin-300.css';
import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import { App } from './App.tsx';
import './styles.css';

const root = document.getElementById('root');
if (root === null) throw new Error('missing #root');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Installable app: the worker opens the app instantly from the home screen. Not in development,
// where a cached shell would hide changes.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      console.error('service worker registration failed', error);
    });
  });
}
